import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('macros');
export const actions = helper.createActions('macros', actionTypes);
